module.exports = __webpack_public_path__ + "static/about-switch-e917c14f1b251a0d59281c38a68599a4.svg";